import cn from 'clsx';

export const Select = ({
                         options,
                         placeholder,
                         name,
                         defaultValue,
                         register,
                         validations,
                         className,
                         inputClassName,
                         ...inputprops
                       }) => {
  const defaultClassName =
    'relative peer w-full max-w-[500px] border border-1 border-neutral-600 bg-white dark:bg-white';
  return (
    <div className={className ?? defaultClassName}>
      <select
        className={cn(
          'px-2 py-1 md:px-4 md:py-2 w-full bg-white text-black rounded-none',
          'active:border-0 active:outline-0 focus:border-neutral-800 focus:border-2',
          'focus:outline-0 focus:outline-transparent',
          'focus:border-neutral-800 focus:border-1',
          'autofill:bg-transparent text-sm md:text-base h-[38px] lg:h-[48px]',
          inputClassName
        )}
        defaultValue={defaultValue}
        {...(register ? register(name, validations) : {})}
        {...inputprops}
      >
        {placeholder && <option value="" label={placeholder}/>}
        {options &&
          options?.map((option, index) => (
            // <option key={`${name}_${index}`} value={option.value || ''} className="text-black">
            //   {option.label || ''}
            // </option>

            <option
              key={`${name}_${index}`}
              value={option?.val || option?.value || ''} // Use "val" for the value
              className="text-black"
              disabled={option?.disabled} // Support disabled property
            >
              {option?.text || option?.label || ''}
            </option>
          ))}
      </select>
    </div>
  );
};
